/**
 * @documental
 * @export Span
 * @name
 * Grid.Span
 */

import { FC, ReactNode } from "react";

/**
 * The `Span` component properties.
 */
export interface SpanProps {
  /**
   * The number of columns to span between 1 and 12. If the span exceeds the bounds of
   * the grid, it will be placed on the next line.
   */
  readonly columns: number;

  /**
   * The component to span.
   */
  readonly children?: ReactNode;
}

/**
 * A component which specifies how many columns to span its child across within the `Grid`.
 */
export const Span: FC<SpanProps> = () => {
  return null;
};
